import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import TranscriptPage from './pages/TranscriptPage'
import NotFoundPage from './pages/NotFoundPage'
import VersionBadge from './components/VersionBadge'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'

// User pages
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import NewProjectPage from './pages/NewProjectPage'

// Admin pages
import AdminLayout from './components/admin/AdminLayout'
import AdminLoginPage from './pages/admin/LoginPage'
import AdminDashboardPage from './pages/admin/DashboardPage'
import PipelinesPage from './pages/admin/PipelinesPage'
import StagePage from './pages/admin/StagePage'
import ProjectsPage from './pages/admin/ProjectsPage'
import ModelsPage from './pages/admin/ModelsPage'

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50">
        <VersionBadge />
        <Routes>
          {/* Home page */}
          <Route path="/" element={<HomePage />} />

          {/* User auth routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected user routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-project"
            element={
              <ProtectedRoute>
                <NewProjectPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:projectId"
            element={
              <ProtectedRoute>
                <TranscriptPage />
              </ProtectedRoute>
            }
          />

          {/* Public transcript view (token-based) */}
          <Route path="/view/:token" element={<TranscriptPage />} />

          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="pipelines" element={<PipelinesPage />} />
            <Route path="pipelines/:stageId" element={<StagePage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="models" element={<ModelsPage />} />
          </Route>

          <Route path="/error" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </AuthProvider>
  )
}

export default App
